import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const autoSignOut = (autoSignOutInHours: number): AxiosPromise => {
  return instance.post('api/visitors/autoSignOut', { autoSignOutInHours });
};

export default autoSignOut;
